import React from 'react'
import logo from '../../../assets/static/logo-planalto.png'

const LogotipoPlanalto = () => (
	<img className="logotipo-planalto" src={logo} alt="Logotipo Planalto" />
)

export default LogotipoPlanalto
